import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { createPolymorphicComponent } from '@mantine/utils';
import useStyles from './ActionIcon.styles.js';
import { Loader } from '../Loader/Loader.js';
import { UnstyledButton } from '../UnstyledButton/UnstyledButton.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  color: "gray",
  size: "md",
  variant: "subtle"
};
var _ActionIcon = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("ActionIcon", defaultProps, props),
    className = _a.className,
    color = _a.color,
    children = _a.children,
    radius = _a.radius,
    size = _a.size,
    variant = _a.variant,
    gradient = _a.gradient,
    disabled = _a.disabled,
    loaderProps = _a.loaderProps,
    loading = _a.loading,
    unstyled = _a.unstyled,
    __staticSelector = _a.__staticSelector,
    others = __objRest(_a, ["className", "color", "children", "radius", "size", "variant", "gradient", "disabled", "loaderProps", "loading", "unstyled", "__staticSelector"]);
  var _useStyles = useStyles({
      radius: radius,
      color: color,
      gradient: gradient
    }, {
      name: ["ActionIcon", __staticSelector],
      unstyled: unstyled,
      size: size,
      variant: variant
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx,
    theme = _useStyles.theme;
  var loader = /* @__PURE__ */React.createElement(Loader, __spreadValues({
    color: theme.fn.variant({
      color: color,
      variant: variant
    }).color,
    size: "100%",
    "data-action-icon-loader": true
  }, loaderProps));
  return /* @__PURE__ */React.createElement(UnstyledButton, __spreadValues({
    className: cx(classes.root, className),
    ref: ref,
    disabled: disabled,
    "data-disabled": disabled || void 0,
    "data-loading": loading || void 0,
    unstyled: unstyled
  }, others), loading ? loader : children);
});
_ActionIcon.displayName = "@mantine/core/ActionIcon";
var ActionIcon = createPolymorphicComponent(_ActionIcon);
export { ActionIcon, _ActionIcon };